export const LOAD_ATTACHMENTS_SIGNAL =
  'edrolo/attachments/LOAD_ATTACHMENTS_SIGNAL';
export const LOAD_ATTACHMENTS_REQUEST =
  'edrolo/attachments/LOAD_ATTACHMENTS_REQUEST';
export const LOAD_ATTACHMENTS_FAILURE =
  'edrolo/attachments/LOAD_ATTACHMENTS_FAILURE';
export const LOAD_ATTACHMENTS_SUCCESS =
  'edrolo/attachments/LOAD_ATTACHMENTS_SUCCESS';

export const loadAttachments = {
  signal: (classId, attachmentType, objectId, isDemo) => ({
    type: LOAD_ATTACHMENTS_SIGNAL,
    payload: { classId, attachmentType, objectId, isDemo },
  }),
  request: (classId, attachmentType, objectId) => ({
    type: LOAD_ATTACHMENTS_REQUEST,
    payload: { classId, attachmentType, objectId },
  }),
  success: (classId, attachmentType, objectId, data) => ({
    type: LOAD_ATTACHMENTS_SUCCESS,
    payload: { classId, attachmentType, objectId, data },
  }),
  failure: (classId, attachmentType, objectId, failureReason) => ({
    type: LOAD_ATTACHMENTS_FAILURE,
    payload: { classId, attachmentType, objectId, failureReason },
  }),
};
